import type { RouteRecordRaw } from 'vue-router'
import { NotificationIcon } from '@/components/icons'

export const NotificationRoutes: RouteRecordRaw[] = [
  {
    path: '/notifications',
    component: () => import('@/layouts/dashboard-layout/index.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'notifications',
        component: () => import('@/views/notifications/index.vue'),
        meta: {
          title: 'اعلان‌ها',
          breadcrumb: [
            { text: 'اعلان‌ها', to: '/notifications', icon: NotificationIcon }
          ]
        }
      }
    ]
  }
]
